// We are using a `Symbol` to guarentee the whole object is a particular shape
export const treeItemDataPrivateKey = Symbol('TreeItemData');
